import React, { Fragment, useContext, useRef } from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import "../style/Appbar.scss";
import Button from "@material-ui/core/Button";
import { Container, Row, Col, Card } from "bootstrap-4-react";
import { isLogin, getName, getUsername, getID } from "../utils";
import { Link, useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Popover from "@material-ui/core/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ImageIcon from "@material-ui/icons/Image";
import WorkIcon from "@material-ui/icons/Work";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import logo from "../images/navdisha.png";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import logonew from "../images/Navdisha-Logo-2024-20240430-062400.jpg";
import logo1 from "../images/Navdisha-Logo-new.jpg";
import Navmenu from "../components/Navmenu";
import { useEffect, useState } from "react";
import ReactGA from "react-ga";
import { Tooltip, Paper } from "@material-ui/core";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { apiURL } from "../utils";
import axios from "axios";
import Moment from "moment";
import { useProfile } from "../utils/UserContext";
import { PWAContext, usePWA } from "../utils/PwaAppContext";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  popover: {
    maxWidth: "300px",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function PrimarySearchAppBar() {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [upcomingEvent, setUpcomingEvent] = useState([]);
  const [otherNotification, setOtherNotification] = useState([]);
  const [notifications, setNotifications] = useState([])
  // FIX: Read count from localStorage on mount so the badge shows the correct value
  // immediately when navigating between pages (each page has its own Appbar instance,
  // so React state resets on every route change — localStorage persists across mounts)
  const [count, setCount] = useState(() => {
    const saved = localStorage.getItem("navdisha_notif_count");
    return saved !== null ? parseInt(saved, 10) : 0;
  });
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { userName } = useProfile();
  const popoverRef = useRef(null);
  const { isPWA } = usePWA();
  const PWA = useContext(PWAContext);


  useEffect(() => {
    function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [open, setOpen]);

  // FIX: Whenever count changes, save it to localStorage
  // This ensures the updated count is available immediately when navigating to another page
  useEffect(() => {
    localStorage.setItem("navdisha_notif_count", count);
  }, [count]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleToggle = () => {
    if (!isLogin()) {
      history.push("/sign");
    } else {
      setOpen(!open);
      if (!open) {
        fetchNotification();
      }
    }
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const history = useHistory();

  const handleLogOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const userData = JSON.parse(localStorage.getItem("user_detail"));
    // PWA.isPWA && PWA &&
    //   window.ReactNativeWebView?.postMessage(
    //     JSON.stringify({ type: "LOGOUT_DETAILS", data: userData })
    //   );
    window.localStorage.clear();
    setOpen(false);
    handleMenuClose();
    history.push("/sign");
  };
  const handleProfile = (e) => {
    e.preventDefault();
    history.push("/profile-info");
  };
  const handleBookMark = (e) => {
    e.preventDefault();
    history.push("/bookmark");
  };
  const handleAchievement = (e) => {
    e.preventDefault();
    history.push("/achievements");
  };

  const fetchNotification = () => {
    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };
    axios
      .get(apiURL("Site_notification/notifications/" + getID()), {
        headers: headers,
      })
      .then((response) => {
        const resultData = response.data;

        if (resultData.status === true || resultData.status === 1) {
          // setUpcomingEvent(resultData.notifications.webinar);
          // setOtherNotification(resultData.notifications.others);
          setNotifications(resultData.notifications)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchCount = () => {
    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };
    const body = {
      user_id: getID(),
    };
    axios
      .post(apiURL("Site_notification/count_notification"), body, {
        headers: headers,
      })
      .then((response) => {
        const resultData = response.data;

        if (resultData.status === true || resultData.status === 1) {
          setCount(resultData.result);
          // FIX: Save the latest count from server to localStorage so other pages read it correctly
          localStorage.setItem("navdisha_notif_count", resultData.result);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleReadMore = (
    e,
    id,
    title,
    type,
    notification_id,
    event_type,
    category
  ) => {
    // FIX: Optimistic UI update - instantly remove the clicked notification from local state
    // so the badge count decreases right away without waiting for the API response
    // Previously, the count only updated after a slow async roundtrip (mark_as_read → fetchCount)
    setNotifications((prev) => prev.filter((n) => n.id !== notification_id)); // remove clicked notification from list immediately
    setCount((prev) => {
      const newCount = Math.max(0, prev - 1);
      // FIX: Also save the decremented count to localStorage immediately
      // so the new page's Appbar reads the correct (lower) count when it mounts
      localStorage.setItem("navdisha_notif_count", newCount);
      return newCount;
    });
    setOpen(false); // close the popup immediately when any notification is clicked

    // Navigate to the appropriate page based on the notification type
    if (type === "Upcoming" && event_type === "Cancelled") {
      readNotification(notification_id); // mark as read on server
    } else if (type === "Upcoming" && event_type !== "Cancelled") {
      history.push("/webinar/" + id + "/" + title);
    } else if (type === "Past Webinar") {
      history.push("/past-webinar-schedule/" + id + "/" + title);
    } else if (type === "Past Training") {
      history.push("/training/" + id + "/" + title);
    } else if (type === "Articles") {
      history.push("/article/" + id + "/" + title, { category });
    } else if (type === "Blogs") {
      history.push("/blog/" + id + "/" + title, { category: "Blogs" });
    } else if (type === "Govt.Circulars/GR") {
      history.push("/news/" + id + "/" + title);
    } else if (type === "Videos") {
      history.push("/video");
    }
    readNotification(notification_id); // call API to mark this notification as read on the server
  };
  const readNotification = (id) => {
    const headers = {
      "Content-type": "application/json",
    };
    const body = {
      notification_id: id,
      user_id: getID(),
    };
    axios
      .post(apiURL("Site_notification/mark_as_read"), body, {
        headers: headers,
      })
      .then((response) => {
        const resultData = response.data;
        if (resultData.status === true || resultData.status === 1) {
          // FIX: After mark-as-read API succeeds, sync the real values from the server
          // Previously only fetchCount() was called and setOpen(false) closed the popup abruptly
          fetchCount();        // re-fetch true unread count from server to confirm optimistic update
          fetchNotification(); // FIX: also refresh the notification list so popup stays in sync
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function timeSince(dateString) {
    const dateTimeAgo = moment(dateString).fromNow();
    return dateTimeAgo;
  }
  const handleContactUs = () => {
    history.push("/contact-us")
  }
  const handleAboutUs = () => {
    history.push("/about-us")
  }
  const handleFaq = () => {
    history.push("/faq")
  }

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      className="profileMenu"
      variant="popover"
    >
      <MenuItem onClick={handleProfile}>Profile</MenuItem>
      <MenuItem onClick={handleBookMark}>My Bookmarks</MenuItem>
      <MenuItem onClick={handleAchievement}>My Achievements</MenuItem>
      {/* {isPWA &&
      <>
        <MenuItem onClick={handleContactUs}>Contact Us</MenuItem>
        <MenuItem onClick={handleAboutUs}>About Us</MenuItem>
        <MenuItem onClick={handleFaq}>FAQ</MenuItem>
      </>} */}
      <MenuItem onClick={handleLogOut}>
        Logout
        <img src="../images/logout.png" alt="" className="logoutImg" />
      </MenuItem>

      {/*<MenuItem onClick={handleMenuClose}>Profile </MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>*/}
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "right", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      className="profileMobileMenu"
    >
      <MenuItem>
        {isLogin() ? (
          <Button onClick={handleProfileMenuOpen}> {getUsername()} </Button>
        ) : (
          <Link to={"/sign"}>
            <Button> SIGN IN </Button>
          </Link>
        )}
      </MenuItem>

      <MenuItem>
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState) => (
            <div>
              {/* <Button variant="contained" color="primary" >
            Open Popover
          </Button> */}
              <div {...bindTrigger(popupState)}>
                <IconButton
                  aria-label="show 17 new notifications"
                  color="inherit"
                >
                  <Badge badgeContent={4} color="secondary">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
              </div>

              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "right",
                  horizontal: "right",
                }}
              >
                <Box p={0}>
                  <List>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>
                          <ImageIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Lorem Ipsum has been the industry's  standard dummy text ever sinces"
                        secondary="Jan 9, 2014"
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>
                          <WorkIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Lorem Ipsum has been the industry's standard dummy text ever since"
                        secondary="Jan 7, 2014"
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>
                          <BeachAccessIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Vacation"
                        secondary="July 20, 2014"
                      />
                    </ListItem>
                  </List>
                </Box>
              </Popover>
            </div>
          )}
        </PopupState>
      </MenuItem>
    </Menu>
  );

  useEffect(() => {
    ReactGA.initialize("UA-179012541-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    //console.log('this url '+window.location.pathname + window.location.search);
  }, []);
  useEffect(() => {
    if (isLogin()) {
      // FIX: Delay the initial fetchCount by 3 seconds on mount.
      // Problem: When user clicks a notification and navigates to a new page,
      // the new page's Appbar mounts and immediately calls fetchCount().
      // But mark_as_read API may not have completed yet, so the server still
      // returns the old count — overwriting our correct optimistic value.
      // The localStorage value is shown instantly; after 3s we sync with server.
      const initialFetchDelay = setTimeout(() => fetchCount(), 1000); // 1 second delay — gives mark_as_read API time to finish
      const intervalId = setInterval(fetchCount, 10000); // re-fetch every 10 seconds

      return () => {
        clearTimeout(initialFetchDelay); // cleanup delay timer on unmount
        clearInterval(intervalId);       // cleanup interval on unmount
      };
    }
  }, []);
  return (
    <div className={`${classes.grow} mobileSticky   pb-3 sticky-top`}>
      {/* <AppBar position="static"  className="customBar1 sticky-top"> */}
      <AppBar position="static" className="customBar1 sticky-top">
        <Row className="mx-0">
          <Col>
            <Toolbar className="px-0">
              {/* <img src="../assets/images/logo.png" className="img-fluid logoBox"  />  */}

              <div className="d-flex justify-content-between w-100">
                <div>
                  <Link to={"/"}>
                    <img
                      src={logonew}
                      className={isPWA ? "img-fluid logoBoxMobile" : "img-fluid logoBox"}
                      width="179px"
                      height="69px"
                    />
                  </Link>
                </div>
                <div>
                  {" "}
                  <Navmenu />{" "}
                </div>
                <div>
                  <div className={classes.grow} />
                  <div className={classes.sectionDesktop}>
                    {isLogin() ? (
                      <Button onClick={handleProfileMenuOpen}>
                        {/* <PersonAddIcon className="d-block d-lg-none " />{" "} */}
                        <span className=" d-md-block d-block d-lg-none">
                          { }
                          {userName ? userName?.charAt(0) : getUsername().charAt(0)}
                        </span>
                        <span className="d-none d-lg-block">
                          {" "}
                          {userName ? userName : getUsername()}
                        </span>
                      </Button>
                    ) : (
                      <Tooltip title={"Existing Users"}>
                        <Link
                          to={{
                            pathname: "/sign",
                            state: { value: 0 },
                          }}
                        >
                          <Button>
                            {" "}
                            <PersonAddIcon className="d-block d-lg-none " />{" "}
                            <span className="d-none d-lg-block"> SIGN IN </span>{" "}
                          </Button>
                        </Link>
                      </Tooltip>
                    )}
                    <div className="notificationBox">
                      <IconButton color="inherit" onClick={handleToggle}>
                        <Badge badgeContent={count} color="secondary" showZero>
                          <NotificationsIcon />
                        </Badge>
                      </IconButton>
                      {/* FIX: Removed `count > 0 && notifications.length > 0` condition */}
                      {/* Previously the popup would completely disappear when the last notification was read */}
                      {/* Now it stays open and shows an empty state message instead */}
                      {open && (
                        <Paper elevation={3} className="notificationPaper" ref={popoverRef}>
                          {/* FIX: Show empty state when all notifications have been read */}
                          {/* Previously the popup just vanished — now user gets clear feedback */}
                          {notifications.length === 0 ? (
                            <div className="eventContainer" style={{ justifyContent: "center", padding: "16px" }}>
                              <div className="eventInfo" style={{ textAlign: "center" }}>
                                <p style={{ color: "#888", margin: 0 }}>No new notifications</p>
                              </div>
                            </div>
                          ) : (
                            <Fragment>
                              {notifications.map((event) => (
                                event.type == "Upcoming" ?
                                  <div
                                    key={event.id}
                                    className="eventContainer"
                                    onClick={(e) =>
                                      handleReadMore(
                                        e,
                                        event.content_id,
                                        event.content
                                          .replace(/ /g, "-")
                                          .toLowerCase(),
                                        event.type,
                                        event.id,
                                        event.event_type
                                      )
                                    }
                                  >
                                    <div className="eventIcon">
                                      <EventAvailableIcon />
                                    </div>
                                    <div className="eventInfo">
                                      <h4>
                                        {event.event_type === "Cancelled"
                                          ? "Event Cancelled"
                                          : event.event_type === "Edited"
                                            ? "Event Updated"
                                            : "New Event Added"}
                                      </h4>
                                      <p>Upcoming Event - {event.content}</p>
                                      <div className="updates">
                                        <span>
                                          Updated: {timeSince(event.created_at)}{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div> :
                                  <div
                                    key={event.id}
                                    className="eventContainer"
                                    onClick={(e) =>
                                      handleReadMore(
                                        e,
                                        event.content_id,
                                        event.content
                                          .replace(/ /g, "-")
                                          .toLowerCase(),
                                        event.type,
                                        event.id,
                                        event.event_type,

                                        event.category_name
                                      )
                                    }
                                  >
                                    <div className="eventIcon">
                                      <EventAvailableIcon />
                                    </div>
                                    <div className="eventInfo">
                                      <p>
                                        {event.type} - {event.content}
                                      </p>
                                      <div className="updates">
                                        <span>
                                          Updated: {timeSince(event.created_at)}{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                              ))}
                            </Fragment>
                          )}
                          {/* {otherNotification !== 0 && (
                            <Fragment>
                              {otherNotification.map((event) => (
                                <div
                                  className="eventContainer"
                                  onClick={(e) =>
                                    handleReadMore(
                                      e,
                                      event.content_id,
                                      event.content
                                        .replace(/ /g, "-")
                                        .toLowerCase(),
                                      event.type,
                                      event.id,
                                      event.event_type,

                                      event.category_name
                                    )
                                  }
                                >
                                  <div className="eventIcon">
                                    <EventAvailableIcon />
                                  </div>
                                  <div className="eventInfo">
                                    <p>
                                      {event.type} - {event.content}
                                    </p>
                                    <div className="updates">
                                      <span>
                                        Updated: {timeSince(event.created_at)}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Fragment>
                          )} */}
                        </Paper>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Toolbar>
          </Col>
        </Row>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}